
export const cashbotName = 'na';
